<template>
  <div>
    <stripe-iban-element></stripe-iban-element>
  </div>
</template>

<script>

// import { mapGetters } from 'vuex'
// import StripePay from '~/components/StripePay.vue'

import StripeIbanElement from '~/components/dashboard/StripeIbanElement.vue'

export default {
  components: {
        // StripePay,
    StripeIbanElement

  },
  name: 'home-view',
  metaInfo () {
    return { title: 'Premium' }
  },

  created () {

  },
  data: function () {
    return {
             //   e1: '4',

    }
  }

}
</script>


